exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.radius[data-v-60490d3b] {\n  border-radius: 50%;\n}\n.pl8[data-v-60490d3b] {\n  padding-left: 8px;\n}\n", "", {"version":3,"sources":["/Volumes/aigoWork/Workspace/ying-zheng/yz-server/front_end/jjj_shop_multi_shop/src/views/distribution/bindlog/index.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB","file":"index.vue","sourcesContent":["\n.radius[data-v-60490d3b] {\n  border-radius: 50%;\n}\n.pl8[data-v-60490d3b] {\n  padding-left: 8px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-60490d3b","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/distribution/bindlog/index.vue
// module id = 9Y3C
// module chunks = 0